import { useCallback } from "react";
import { useAuthenticationContext } from "../../context/authenticationContext/authenticationContext";
import { useAdminController } from "../useAdminController/useAdminController";

export const useSBDeadLetterResender = (): [
  string | undefined,
  boolean,
  Error | undefined,
  (
    topic: string,
    subscription: string,
    queue: string,
    waitSeconds: number
  ) => Promise<string>
] => {
  const { user } = useAuthenticationContext();
  const { get, response, loading, error } = useAdminController<string>(
    user!,
    false
  );

  const resend = useCallback(
    async (
      topic: string,
      subscription: string,
      queue: string,
      waitSeconds: number
    ) => {
      var endpoint = `resendDeadLetter?waitSeconds=${waitSeconds}`;
      if (topic !== "") {
        endpoint += `&topic=${topic}&subscription=${subscription}`;
      } else {
        endpoint += `&queue=${queue}`;
      }

      let result = await get(endpoint);
      return result;
    },
    [get]
  );

  return [response.data, loading, error, resend];
};
